import Constant from '@/constant';
import soldocAPI from '@/api/soldoc';
import CampaignAuth from '@/utilities/campaignAuth';

// 컨시어지몰 API 공통 처리
// 성공: response.data.data / 실패: { status, code, title, message } (concierge-admin 오류 응답 형식)
function storeRequest(request)
{
    return request
        .then((response) => {
            return response.data ? response.data.data : undefined;
        })
        .catch((err) => {
            var response = err.response || {};
            var data = response.data || {};
            var error = data.success === false && data.data ? data.data : {};
            return Promise.reject({
                status: response.status || null,
                code: error.code || null,
                title: error.title || '',
                message: error.message || '고객센터에 문의 바랍니다'
            });
        });
}

export default {
    [Constant.SAVE_FILE]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.saveFile(payload.file)
                .then((response) => {
                    if(response.data.success == true)
                    {                    
                        resolve(response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    // console.log(JSON.stringify(err.response));
                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
        
    },
    [Constant.CHECK_DIABETES_EXISTS]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.checkDiabetesExists(payload.name, payload.registration_number, payload.token)
                .then((response) => {
                    if(response.data.success == true)
                    {                    
                        resolve(response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.FETCH_TEMP_SAVE_DIABETES]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.fetchTempSaveDiabetes(payload.name, payload.registration_number, payload.token)
                .then((response) => {
                    if(response.data.success == true)
                    {                    
                        resolve(response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.SAVE_FIRST_DIABETES]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.saveFirstDiabets(store.state.new_request_data, payload.token)
                .then((response) => {
                    if(response.data.success == true)
                    {                    
                        resolve(response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.SAVE_REVISIT_DIABETES]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.saveRevisitDiabetes(store.state.revisit_request_data, payload.token)
                .then((response) => {
                    if(response.data.success == true)
                    {                    
                        resolve(response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.TEMP_SAVE_DIABETES]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.tempSaveDiabetes(store.state.files, store.state.body, payload.token)
                .then((response) => {
                    if(response.data.success === true)
                    {                    
                        resolve(response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    //my page
    [Constant.SIGNIN_DIABETES_USER]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.signinDiabetesUser(payload.kakao_access_token)
                .then((response) => {
                    if(response.data.success == true)
                    {                    
                        resolve(response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.SIGNIN_AGREEMENT]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.signinAgreement(payload.agreement_service, payload.agreement_personal_info, payload.agreement_marketing, payload.token)
                .then((response) => {
                    // concierge-admin은 201에 본문이 없음
                    if(response.status === 201 || response.data.success == true)
                    {                  
                        resolve();
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.FETCH_DIABETES_USER_PROFILES]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.fetchDiabetesUserProfiles(payload.token)
                .then((response) => {
                    if(response.data.success == true)
                    {                    
                        store.commit(Constant.FETCH_DIABETES_USER_PROFILES, {
                            profiles: response.data.data
                        })
                        resolve(response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.UPDATE_DIABETES_USER_CARD]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.updateDiabetesUserCard(store.state.cardchange_request_data, payload.token)
                .then((response) => {
                    if(response.data.success == true)
                    {                    
                        resolve(response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.FETCH_DIABETES_SETTLEMENT]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.fetchDiabetesSettlement(payload.profile_id, payload.token)
                .then((response) => {
                    if(response.data.success == true)
                    {            
                        store.commit(Constant.FETCH_DIABETES_SETTLEMENT, {
                            settlements: response.data.data
                        })
                        resolve();
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.FETCH_DIABETES_HISTORY]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.fetchDiabetesHistory(payload.profile_id, payload.token)
                .then((response) => {
                    if(response.data.success == true)
                    {            
                        store.commit(Constant.FETCH_DIABETES_HISTORY, {
                            diabetes_histories: response.data.data
                        })
                        resolve();
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.FETCH_DIABETES_DOCUMENT]: (store, payload) => {
        return new Promise((resolve, reject) => {
            
            soldocAPI.fetchDiabetesDocument(payload.reception_numbers, payload.token)
                .then((response) => {
                    if(response.data.success == true)
                    {            
                        store.commit(Constant.FETCH_DIABETES_DOCUMENT, {
                            diabetes_documents: response.data.data
                        })
                        resolve();
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.FETCH_DIABETES_VOC_PAGE]: (store, payload) => {
  
         var pageno;
        if (typeof payload == "undefined" || typeof payload.pageno == "undefined")
            pageno = 0;
        else
            pageno = payload.pageno - 1;

        var pagesize = payload.pagesize;

        return new Promise((resolve, reject) => {
            soldocAPI.fetchDiabetesVocPage(pageno, pagesize, payload.sort)
                .then((response) => {
                    if (response.data.status == "success") {
                        store.commit(Constant.FETCH_DIABETES_VOC_PAGE, {
                            pageno: response.data.data.number,
                            pagesize: payload.pagesize,
                            totalcount: response.data.data.totalElements,
                            vocs: response.data.data.content,
                            allCount: response.data.count
                        });
                        resolve();
                    }
                    else
                    {
                        reject();
                    }
                })
                .catch((err) => {
                    reject(err);
                })
        })

    },
    [Constant.ADD_DIABETES_VOC]: (store, payload) => {
        return new Promise((resolve, reject) => {
            const token = CampaignAuth.getToken();
            if(token === null)
            {
                // 토큰이 없으면 바로 카카오 로그인
                CampaignAuth.relogin(true);
                reject();
                return;
            }

            soldocAPI.addDiabetesVoc(store.state.vocDiabetes, token)
                .then((response) => {
                    if(response.data.status == "success")
                    {            
                        resolve();
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    // 인증 실패(401/502)는 에러 메시지 대신 카카오 로그인으로 이동
                    if(CampaignAuth.isAuthError(err))
                    {
                        CampaignAuth.relogin(true);
                        reject();
                        return;
                    }

                    if(err.response && err.response.data.status === "fail")
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.UPDATE_DIABETES_VOC]: (store, payload) => {
        return new Promise((resolve, reject) => {
            const token = CampaignAuth.getToken();
            if(token === null)
            {
                // 토큰이 없으면 바로 카카오 로그인
                CampaignAuth.relogin(false);
                reject();
                return;
            }

            soldocAPI.updateDiabetesVoc(store.state.vocDiabetes, token)
                .then((response) => {
                    if(response.data.status == "success")
                    {            
                        resolve();
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    // 인증 실패(401/502)는 에러 메시지 대신 카카오 로그인으로 이동
                    if(CampaignAuth.isAuthError(err))
                    {
                        CampaignAuth.relogin(false);
                        reject();
                        return;
                    }

                    if(err.response && err.response.data.status === "fail")
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.UPDATE_DIABETES_USER_DELIVERY]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.updateDiabetesUserDelivery(payload.address, payload.detailAddress, payload.zipCode, payload.addressNickname, payload.addressDescription, payload.profileId, payload.token)
                .then((response) => {
                    if(response.data.success == true)
                    {            
                        resolve();
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    // v2
    [Constant.SIGNIN_KAKAO]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.signinKakao(payload.kakao_access_token)
                .then((response) => {
                    if(response.data.success == true)
                    {                    
                        resolve(response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {

                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.SIGNIN_AGREEMENT]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.signinAgreement(payload.agreement_service, payload.agreement_personal_info, payload.agreement_marketing, payload.token)
                .then((response) => {
                    if(response.data.success == true)
                    {                  
                        resolve();
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.FETCH_PROFILES]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.fetchProfiles(payload.token)
                .then((response) => {
                    if(response.data.success == true)
                    {              
                        store.commit(Constant.FETCH_PROFILES, {
                            diabetes_profiles: response.data.data
                        })
                        resolve(response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    reject();
                    // if(err.response.data.success === false)
                    // {
                    //     reject(err.response.data.data);
                    // }
                    // else 
                    // {
                    //     reject("고객센터에 문의 바랍니다");
                    // }
                })
        })
    },
    [Constant.FETCH_EXPECTED_DATE]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.fetchExpectedDate(payload.token)
                .then((response) => {
                    if(response.data.success == true)
                    {              
                        resolve(response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    reject();
                    // if(err.response.data.success === false)
                    // {
                    //     reject(err.response.data.data);
                    // }
                    // else 
                    // {
                    //     reject("고객센터에 문의 바랍니다");
                    // }
                })
        })
    },
    [Constant.ADD_DRAFT_PROFILE]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.addDraftProfile(store.state.draftProfile, payload.token)
                .then((response) => {
                    if(response.data.success == true)
                    {              
                        resolve(response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.SAVE_DELEGATE_FALSE]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.saveDelegateFalse(payload.profile_id, payload.token)
                .then((response) => {
                    // concierge-admin은 201에 본문이 없음
                    if(response.status === 201 || response.data.success == true)
                    {              
                        resolve(response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.SAVE_DELEGATE_WITH_ADDITION]: (store, payload) => {
        return new Promise((resolve, reject) => {

            soldocAPI.saveDelegateWithAddition(store.state.delegateWithAddition, payload.profile_id, payload.token)
                .then((response) => {
                    // concierge-admin은 201에 본문이 없음
                    if(response.status === 201 || response.data.success == true)
                    {              
                        resolve(response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.SAVE_CARD]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.saveCard(store.state.cardInfo, payload.profile_id, payload.token)
                .then((response) => {
                    if(response.data.success == true)
                    {              
                        resolve(response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.REGISTER_PROFILE]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.registerProfile(payload.profile_id, payload.token)
                .then((response) => {
                    if(response.data.success == true)
                    {              
                        resolve(response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.FETCH_PROFILE]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.fetchProfile(payload.profile_id, payload.token)
                .then((response) => {
                    if(response.data.success == true)
                    {              
                        store.commit(Constant.FETCH_PROFILES, {
                            diabetes_profiles: response.data.data
                        })
                        resolve(response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
             
                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.UPDATE_PROFILE]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.updateProfile(payload.phoneNumber, payload.profile_id, payload.token)
                .then((response) => {
                    if(response.data.success == true)
                    {              
                        resolve(response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.UPDATE_CARD]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.updateCard(store.state.cardInfo, payload.profile_id, payload.token)
                .then((response) => {
                    if(response.data.success == true)
                    {              
                        resolve(response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.DELETE_CARD]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.deleteCard(payload.profile_id, payload.token)
                .then((response) => {
                    
                    if(response.status === 204)
                    {              
                        resolve();
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {

                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.UPDATE_DELIVERY]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.updateDelivery(store.state.delivery, payload.profile_id, payload.token)
                .then((response) => {
                    if(response.data.success == true)
                    {              
                        resolve(response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.SAVE_DELEGATE]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.saveDelegate(store.state.delegateWithAddition, payload.profile_id, payload.token)
                .then((response) => {
                    // concierge-admin은 201에 본문이 없음
                    if(response.status === 201 || response.data.success == true)
                    {              
                        resolve(response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.SAVE_DELEGATE_ADDTION]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.saveDelegateAddition(store.state.delegateWithAddition.additional_info, payload.profile_id, payload.token)
                .then((response) => {
                    if(response.status === 204)
                    {              
                        resolve();
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.FETCH_USAGE]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.fetchUsage(payload.profile_id, payload.token)
                .then((response) => {
                    if(response.data.success == true)
                    {              
                        store.commit(Constant.FETCH_USAGE, {
                            diabetes_histories: response.data.data
                        })
                        resolve(response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.FETCH_DOCUMENTS]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.fetchDocuments(payload.reception_numbers, payload.token)
                .then((response) => {
                    if(response.data.success == true)
                    {              
                        store.commit(Constant.FETCH_DIABETES_DOCUMENT, {
                            diabetes_documents: response.data.data
                        })
                        resolve();
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {
                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.FETCH_YEAR_TAX]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.fetchYearTax(payload.profile_id, payload.token)
                .then((response) => {
                    if(response.data.success == true)
                    {            
                        store.commit(Constant.FETCH_YEAR_TAX, {
                            settlements: response.data.data
                        })
                        resolve();
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {

                    if(err.response.data.success === false)
                    {
                        reject(err.response.data.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.FETCH_INVITE_CODE]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.fetchInviteCode(payload.token)
                .then((response) => {
                    if(response.data.success == true)
                    {
                        resolve(response.data);
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {

                    if(err.response.data.success === false)
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.FETCH_INVITE_FRIENDS]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.fetchInviteFriends(payload.token)
                .then((response) => {
                    if(response.data.success == true)
                    {
                        resolve(response.data);
                    }
                    else
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {

                    if(err.response.data.success === false)
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                    else
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    [Constant.APPLY_INVITE_CODE]: (store, payload) => {
        return new Promise((resolve, reject) => {
            soldocAPI.applyInviteCode(payload.code, payload.token)
                .then((response) => {
                    if(response.data.success == true)
                    {
                        resolve();
                    }
                    else 
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
                .catch((err) => {

                    if(err.response.data.success === false)
                    {
                        reject(err.response.data);
                    }
                    else
                    {
                        reject("고객센터에 문의 바랍니다");
                    }
                })
        })
    },
    // 컨시어지몰
    [Constant.FETCH_STORE_CATEGORIES]: (store, payload) => {
        return storeRequest(soldocAPI.fetchStoreCategories(payload.profile_id, payload.token));
    },
    [Constant.FETCH_STORE_PRODUCTS]: (store, payload) => {
        return storeRequest(soldocAPI.fetchStoreProducts(payload.profile_id, payload.category_id, payload.token));
    },
    [Constant.CALC_STORE_COST]: (store, payload) => {
        return storeRequest(soldocAPI.calcStoreCost(payload.cost, payload.token));
    },
    [Constant.FETCH_CART]: (store, payload) => {
        return storeRequest(soldocAPI.fetchCart(payload.profile_id, payload.date_count, payload.recipient_type_code, payload.is_delegation_claim, payload.token));
    },
    [Constant.UPDATE_CART_ITEMS]: (store, payload) => {
        return storeRequest(soldocAPI.updateCartItems(payload.profile_id, payload.items, payload.token));
    },
    // presigned URL 발급 → S3 업로드 → 장바구니 첨부 등록
    [Constant.UPLOAD_CART_FILES]: (store, payload) => {
        var files = payload.files;
        var specs = files.map((file) => ({ name: file.name, type: file.type }));

        return storeRequest(soldocAPI.fetchCartFilePresignedUrl(payload.profile_id, specs, payload.token))
            .then((data) => {
                var presignedUrls = data.presigned_urls || {};
                var urls = Object.keys(presignedUrls).map((key) => presignedUrls[key]);

                return Promise.all(files.map((file, index) => {
                    var presignedUrl = presignedUrls[file.name] || urls[index];
                    return soldocAPI.uploadCartFile(presignedUrl, file)
                        .then(() => ({
                            name: file.name,
                            url: presignedUrl.split('?')[0],
                            type: file.type,
                            size: file.size
                        }));
                }))
                .catch(() => Promise.reject({ status: null, code: null, title: '', message: '파일을 올리지 못했어요. 다시 시도해 주세요.' }));
            })
            .then((uploaded) => {
                return storeRequest(soldocAPI.addCartFiles(payload.profile_id, uploaded, payload.token));
            });
    },
    [Constant.DELETE_CART_FILE]: (store, payload) => {
        return storeRequest(soldocAPI.deleteCartFile(payload.file_id, payload.profile_id, payload.token));
    },
    [Constant.COPY_CART_FROM_ORDER]: (store, payload) => {
        return storeRequest(soldocAPI.copyCartFromOrder(payload.reception_number, payload.profile_id, payload.token));
    },
    [Constant.CHECKOUT_CART]: (store, payload) => {
        return storeRequest(soldocAPI.checkoutCart(payload.profile_id, payload.date_count, payload.recipient_type_code, payload.is_delegation_claim, payload.token));
    },
    [Constant.PAY_CART]: (store, payload) => {
        return storeRequest(soldocAPI.payCart(payload.payment, payload.token));
    },
    [Constant.FETCH_STORE_ORDERS]: (store, payload) => {
        return storeRequest(soldocAPI.fetchStoreOrders(payload.profile_id, payload.page, payload.limit, payload.token));
    },
    [Constant.FETCH_ORDER_STATEMENT]: (store, payload) => {
        return storeRequest(soldocAPI.fetchOrderStatement(payload.reception_number, payload.profile_id, payload.token));
    },
    // 카드 등록·교체 - 결과 card_number는 마스킹되어 옴
    [Constant.SAVE_PROFILE_CARD]: (store, payload) => {
        return storeRequest(soldocAPI.saveCard(payload.card, payload.profile_id, payload.token));
    },
    // 성공하면 204 (본문 없음)
    [Constant.DELETE_PROFILE_CARD]: (store, payload) => {
        return storeRequest(soldocAPI.deleteCard(payload.profile_id, payload.token));
    },
    // 배송지 등록·수정 (address, detail_address, zip_code, address_nickname 필수 / address_description 선택)
    [Constant.UPDATE_PROFILE_ADDRESS]: (store, payload) => {
        return storeRequest(soldocAPI.updateDelivery(payload.address, payload.profile_id, payload.token));
    },
}


// WEBPACK FOOTER //
// ./src/store/actions.js